import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-6 bg-slate-50" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <FadeIn data-id="element-54">
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-slate-200 flex flex-col md:flex-row items-center md:items-start gap-6 text-center md:text-left" data-id="element-55">
            <div className="bg-blue-50 p-4 rounded-full shrink-0" data-id="element-56">
              <ShieldCheck className="w-12 h-12 text-blue-600" data-id="element-57" />
            </div>
            <div data-id="element-58">
              <h3 className="text-2xl font-bold text-slate-800 mb-3 flex items-center justify-center md:justify-start gap-2" data-id="element-59">
                GARANTÍA DE RESCATE DE 7 DÍAS
              </h3>
              <p className="text-slate-600 leading-relaxed text-lg" data-id="element-60">
                Pruébalo sin riesgo. Si en 7 días no sientes que la salud de tus
                riñones mejora, que tu hinchazón disminuye o simplemente sientes
                que no es para ti, te devolvemos el 100% de tus $15, sin
                preguntas. No tienes nada que perder y toda tu salud por ganar.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}